import React from 'react'
import { Route, useRouteMatch } from 'react-router-dom'
import Menu from '@/views/app/reports/Menu'
import CastrationsTermalMap from '@/views/app/reports/castrations/CastrationsTermalMap'
import CastrationsPointMap from '@/views/app/reports/castrations/CastrationsPointMap'
import CastrationsClinicTime from '@/views/app/reports/castrations/CastrationsClinicTime'
import CastrationsByClinic from '@/views/app/reports/castrations/CastrationsByClinic'
import CastrationsByMonth from '@/views/app/reports/castrations/CastrationsByMonth'
import CastrationsByBreed from '@/views/app/reports/castrations/CastrationsByBreed'
import CastrationsByProtector from '@/views/app/reports/castrations/CastrationsByProtector'
import CastrationsByNGO from '@/views/app/reports/castrations/CastrationsByNGO'
import CastrationsByCancelationReason from '@/views/app/reports/castrations/CastrationsByCancelationReason'
import CastrationsByRejectionReason from '@/views/app/reports/castrations/CastrationsByRejectionReason'
import CastrationsTime from '@/views/app/reports/castrations/CastrationsTime'
import CastrationsAwaitingBatch from '@/views/app/reports/castrations/CastrationsAwaitingBatch'
import CastrationsByBilling from '@/views/app/reports/castrations/CastrationsByBilling'
import AnimalsInFair from '@/views/app/reports/fairs/AnimalsInFair'
import CommentsByClinicsInApprovedCastrations from '@/views/app/reports/castrations/CommentsByClinicsInApprovedCastrations'
import AnimalsTermalMap from '@/views/app/reports/animals/AnimalsTermalMap'
import AnimalsPointMap from '@/views/app/reports/animals/AnimalsPointMap'
import ClinicalCareItemClinicBalances from '@/views/app/reports/clinicalCares/ClinicalCareItemClinicBalances'
import ClinicalCaresByMonth from '@/views/app/reports/clinicalCares/ClinicalCaresByMonth'
import ClinicalCaresByYear from '@/views/app/reports/clinicalCares/ClinicalCaresByYear'
import ClinicalCaresByClinic from '@/views/app/reports/clinicalCares/ClinicalCaresByClinic'
import ClinicalCaresByBreed from '@/views/app/reports/clinicalCares/ClinicalCaresByBreed'
import ClinicalCaresByUser from '@/views/app/reports/clinicalCares/ClinicalCaresByUser'
import ClinicalCaresByRegion from '@/views/app/reports/clinicalCares/ClinicalCaresByRegion'
import ClinicalCaresByClassification from '@/views/app/reports/clinicalCares/ClinicalCaresByClassification'
import ClinicalCaresByPriority from '@/views/app/reports/clinicalCares/ClinicalCaresByPriority'
import ClinicalCaresTermalMap from '@/views/app/reports/clinicalCares/ClinicalCaresTermalMap'
import ClinicalCaresPointMap from '@/views/app/reports/clinicalCares/ClinicalCaresPointMap'
import CastrationsByUser from '@/views/app/reports/castrations/CastrationsByUser'
import MonthlyAdoptionsByFair from '@/views/app/reports/fairs/MonthlyAdoptionsByFair'
import CastrationsByYear from '@/views/app/reports/castrations/CastrationsByYear'
import CastrationsByCras from '@/views/app/reports/castrations/CastrationsByCras'
import CastrationsByRegion from '@/views/app/reports/castrations/CastrationsByRegion'
import CastrationsAnnualByClinicAndStatus from '@/views/app/reports/castrations/CastrationsAnnualByClinicAndStatus'
import CastrationsRejectedAndCanceled from '@/views/app/reports/castrations/CastrationsRejectedAndCanceled'
import AdoptionsInFairs from '@/views/app/reports/fairs/AdoptionsInFairs'
import MonthlyAdoptionsByFairManualAndDirect from '@/views/app/reports/adoptions/MonthlyAdoptionsByFairManualAndDirect'
import AdoptionsList from '@/views/app/reports/adoptions/AdoptionsList'
import CastrationsRegistry from '@/views/app/reports/castrations/CastrationsRegistry'
import AdoptionsMenu from '@/views/app/reports/adoptions/Menu'
import AdoptionsByAgeGroup from '@/views/app/reports/adoptions/AdoptionsByAgeGroup'
import AnimalsMenu from '@/views/app/reports/animals/Menu'
import ClinicalCaresMenu from '@/views/app/reports/clinicalCares/Menu'
import FairsMenu from '@/views/app/reports/fairs/Menu'
import CastrationsMenu from '@/views/app/reports/castrations/Menu'
import AdoptionsByFamilyIncome from '@/views/app/reports/adoptions/AdoptionsByFamilyIncome'
import AdoptionsByRegion from '@/views/app/reports/adoptions/AdoptionsByRegion'
import CastrationsOperationalSummary from '@/views/app/reports/castrations/CastrationsOperationalSummary'

function ReportsRoutes() {
  const { path } = useRouteMatch()

  return (
    <div>
      <Route exact path={path}>
        <Menu title="Petis - Parceiros / Relatórios" />
      </Route>

      {/* ADOPTIONS */}
      <Route exact path={`${path}/adoptions/adoptions-list`}>
        <AdoptionsList title="Petis - Parceiros / Lista de adoções" />
      </Route>
      <Route exact path={`${path}/adoptions`}>
        <AdoptionsMenu title="Petis - Parceiros / Relatórios / Adoções" />
      </Route>
      <Route exact path={`${path}/adoptions/monthly-adoptions-by-fair-manual-and-direct`}>
        <MonthlyAdoptionsByFairManualAndDirect title="Petis - Parceiros / Adoções mensais por feira, manuais e diretas" />
      </Route>
      <Route exact path={`${path}/adoptions/adoptions-by-age-group`}>
        <AdoptionsByAgeGroup title="Petis - Parceiros / Adoções por faixa etária" />
      </Route>
      <Route exact path={`${path}/adoptions/adoptions-by-family-income`}>
        <AdoptionsByFamilyIncome title="Petis - Parceiros / Adoções por renda familiar" />
      </Route>
      <Route exact path={`${path}/adoptions/adoptions-by-region`}>
        <AdoptionsByRegion title="Petis - Parceiros / Adoções por região" />
      </Route>

      {/* ANIMALS */}
      <Route exact path={`${path}/animals`}>
        <AnimalsMenu title="Petis - Parceiros / Relatórios / Pets" />
      </Route>
      <Route exact path={`${path}/animals/animals-termal-map`}>
        <AnimalsTermalMap title="Petis - Parceiros / Densidade demográfica de pets" />
      </Route>
      <Route exact path={`${path}/animals/animals-in-map`}>
        <AnimalsPointMap title="Petis - Parceiros / Pets no mapa" />
      </Route>

      {/* CLINICAL CARE */}
      <Route exact path={`${path}/clinical-cares`}>
        <ClinicalCaresMenu title="Petis - Parceiros / Relatórios / Atendimentos Clínicos" />
      </Route>
      <Route exact path={`${path}/clinical-cares/clinical-care-item-clinic-balances`}>
        <ClinicalCareItemClinicBalances title="Petis - Parceiros / Estoque de itens clínicos" />
      </Route>
      <Route exact path={`${path}/clinical-cares/clinical-cares-termal-map`}>
        <ClinicalCaresTermalMap title="Petis - Parceiros / Mapa térmico de atendimentos clínicos" />
      </Route>
      <Route exact path={`${path}/clinical-cares/clinical-cares-in-map`}>
        <ClinicalCaresPointMap title="Petis - Parceiros / Atendimentos clínicos no mapa" />
      </Route>
      <Route exact path={`${path}/clinical-cares/clinical-cares-by-region`}>
        <ClinicalCaresByRegion title="Petis - Parceiros / Atendimentos clínicos por região" />
      </Route>
      <Route exact path={`${path}/clinical-cares/clinical-cares-by-clinic`}>
        <ClinicalCaresByClinic title="Petis - Parceiros / Atendimentos clínicos por clínica" />
      </Route>
      <Route exact path={`${path}/clinical-cares/clinical-cares-by-month`}>
        <ClinicalCaresByMonth title="Petis - Parceiros / Atendimentos clínicos por mês" />
      </Route>
      <Route exact path={`${path}/clinical-cares/clinical-cares-by-year`}>
        <ClinicalCaresByYear title="Petis - Parceiros / Atendimentos clínicos por ano" />
      </Route>
      <Route exact path={`${path}/clinical-cares/clinical-cares-by-breed`}>
        <ClinicalCaresByBreed title="Petis - Parceiros / Atendimentos clínicos por raça e espécie" />
      </Route>
      <Route exact path={`${path}/clinical-cares/clinical-cares-by-classification`}>
        <ClinicalCaresByClassification title="Petis - Parceiros / Atendimentos clínicos por classificação" />
      </Route>
      <Route exact path={`${path}/clinical-cares/clinical-cares-by-priority`}>
        <ClinicalCaresByPriority title="Petis - Parceiros / Atendimentos clínicos por prioridade" />
      </Route>
      <Route exact path={`${path}/clinical-cares/clinical-cares-by-user`}>
        <ClinicalCaresByUser title="Petis - Parceiros / Atendimentos clínicos por usuário" />
      </Route>

      {/* FAIRS */}
      <Route exact path={`${path}/fairs`}>
        <FairsMenu title="Petis - Parceiros / Relatórios / Feiras de adoção" />
      </Route>
      <Route exact path={`${path}/fairs/adoptions-in-fairs`}>
        <AdoptionsInFairs title="Petis - Parceiros / Adoções realizadas nas feiras" />
      </Route>
      <Route exact path={`${path}/fairs/animals-in-fair`}>
        <AnimalsInFair title="Petis - Parceiros / Resumo das feiras de adoção" />
      </Route>
      <Route exact path={`${path}/fairs/monthly-adoptions-by-fair`}>
        <MonthlyAdoptionsByFair title="Petis - Parceiros / Adoções mensais por feira" />
      </Route>

      {/* CASTRATIONS */}
      <Route exact path={`${path}/castrations`}>
        <CastrationsMenu title="Petis - Parceiros / Relatórios / Castrações" />
      </Route>
      <Route exact path={`${path}/castrations/castrations-awaiting-batch`}>
        <CastrationsAwaitingBatch title="Petis - Parceiros / Castrações aguardando lote" />
      </Route>
      <Route exact path={`${path}/castrations/castrations-by-billing`}>
        <CastrationsByBilling title="Petis - Parceiros / Castrações por faturamento" />
      </Route>
      <Route exact path={`${path}/castrations/castrations-termal-map`}>
        <CastrationsTermalMap title="Petis - Parceiros / Mapa térmico de castrações" />
      </Route>
      <Route exact path={`${path}/castrations/castrations-in-map`}>
        <CastrationsPointMap title="Petis - Parceiros / Castrações no mapa" />
      </Route>
      <Route exact path={`${path}/castrations/castrations-clinic-time`}>
        <CastrationsClinicTime title="Petis - Parceiros / Tempo de atendimento" />
      </Route>
      <Route exact path={`${path}/castrations/castrations-by-clinic`}>
        <CastrationsByClinic title="Petis - Parceiros / Castrações por clínica" />
      </Route>
      <Route exact path={`${path}/castrations/comments-by-clinics-in-approved-castrations`}>
        <CommentsByClinicsInApprovedCastrations title="Petis - Parceiros / Comentários das clínicas por castração aprovada" />
      </Route>
      <Route exact path={`${path}/castrations/castrations-by-month`}>
        <CastrationsByMonth title="Petis - Parceiros / Castrações por mês" />
      </Route>
      <Route exact path={`${path}/castrations/castrations-by-year`}>
        <CastrationsByYear title="Petis - Parceiros / Castrações por ano" />
      </Route>
      <Route exact path={`${path}/castrations/castrations-by-breed`}>
        <CastrationsByBreed title="Petis - Parceiros / Castrações por raça" />
      </Route>
      <Route exact path={`${path}/castrations/castrations-by-protector`}>
        <CastrationsByProtector title="Petis - Parceiros / Castrações por protetor(a)" />
      </Route>
      <Route exact path={`${path}/castrations/castrations-by-ngo`}>
        <CastrationsByNGO title="Petis - Parceiros / Castrações por ONG" />
      </Route>
      <Route exact path={`${path}/castrations/castrations-time`}>
        <CastrationsTime title="Petis - Parceiros / Tempo das castrações" />
      </Route>
      <Route exact path={`${path}/castrations/castrations-by-cancelation-reasons`}>
        <CastrationsByCancelationReason title="Petis - Parceiros / Castrações por motivo de cancelamento" />
      </Route>
      <Route exact path={`${path}/castrations/castrations-by-rejection-reasons`}>
        <CastrationsByRejectionReason title="Petis - Parceiros / Castrações por motivo de rejeição" />
      </Route>
      <Route exact path={`${path}/castrations/castrations-by-user`}>
        <CastrationsByUser title="Petis - Parceiros / Castrações por usuário" />
      </Route>
      <Route exact path={`${path}/castrations/castrations-by-cras`}>
        <CastrationsByCras title="Petis - Parceiros / Castrações solicitadas por usuários com CRAS" />
      </Route>
      <Route exact path={`${path}/castrations/castrations-by-region`}>
        <CastrationsByRegion title="Petis - Parceiros / Castrações solicitadas por região" />
      </Route>
      <Route exact path={`${path}/castrations/castrations-annual-by-clinic-and-status`}>
        <CastrationsAnnualByClinicAndStatus title="Petis - Parceiros / Castrações anuais por clínica e status" />
      </Route>
      <Route exact path={`${path}/castrations/castrations-rejected-and-canceled`}>
        <CastrationsRejectedAndCanceled title="Petis - Parceiros / Castrações rejeitadas e canceladas" />
      </Route>
      <Route exact path={`${path}/castrations/castrations-registry`}>
        <CastrationsRegistry title="Petis - Parceiros / Registro de castrações" />
      </Route>
      <Route exact path={`${path}/castrations/castrations-operational-summary`}>
        <CastrationsOperationalSummary title="Petis - Parceiros / Resumo operacional de castrações" />
      </Route>
    </div>
  )
}

export default ReportsRoutes
